/**
 * Parameter keys for Native AI tasks
 * @since 2025.07
 */
export enum NativeAiParameter {
    UserPrompts = "userPrompts",
    FileReferences = "fileReferences",
    SystemPrompts = "systemPrompts",
    UseCustomOptions = "useCustomOptions",
    OptionsJson = "optionsJson",
    OptionsJson_TopP = "topP",
    OptionsJson_Temperature = "temperature",
    ServiceType = "serviceType",
    ModelName = "modelName",
    ServiceEndpoint = "serviceEndpoint",
    ServiceApiKey = "serviceApiKey",
    AuthorizationType = "authorizationType",
    AllowedMcpTools = "allowedMcpTools",
    McpServers = "mcpServers",
    McpToolsCacheKeyGuid = "mcpToolsCacheKeyGuid",
    IncludeReasoningSteps = "includeReasoningSteps",
}
